import React, { Component } from 'react';
import { Rect, Group } from 'react-konva';

export class VerticalTabularDayTimesheetComponentCanvas extends Component {
    render() {
        const { component, isSelected, dimentionsRatio, draggable } = this.props;

        const componentWidthRatio = component.width / 1100.0;
        const componentHeightRatio = component.height / 650.0;

        const smallHeight = 50 * componentHeightRatio * dimentionsRatio;
        const bigHeight = 550 * componentHeightRatio * dimentionsRatio;
        const smallWidth = 100 * componentWidthRatio * dimentionsRatio;
        const bigWidth = 250 * componentWidthRatio * dimentionsRatio;

        const elementsMarginPosX = 50 * componentWidthRatio * dimentionsRatio;
        const elementsPosX = component.drawPositionX + elementsMarginPosX;
        const tableElementsPositionX = elementsPosX + bigWidth + elementsMarginPosX;
        
        const elementsMarginPosY = 50 * componentHeightRatio * dimentionsRatio;
        const descriptionPosY = component.drawPositionY + elementsMarginPosY;
        let tableElementPosY = component.drawPositionY + 50 * componentHeightRatio * dimentionsRatio;
        
        const componentSecundaryColor = "#EBF5FA";
        const componentWidth = component.width * dimentionsRatio;
        const componentHeight = component.height * dimentionsRatio;
        
        const colElements = [];
        let i;
        for (i = 0; i < 6; i++) {
            let j;
            for (j = 0; j < 5; j++) {
                colElements.push(
                    <Rect key={`${i}-${j}`}
                        x={tableElementsPositionX + smallWidth * j + elementsMarginPosX * j}
                        y={tableElementPosY}
                        width={smallWidth}
                        height={smallHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                );

            }

            tableElementPosY += smallHeight + elementsMarginPosY;
        }

        return (
            <Group
                offsetX={component.offsetX}
                offsetY={component.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={component.drawPositionX}
                    y={component.drawPositionY}
                    width={componentWidth}
                    height={componentHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Rect x={elementsPosX}
                        y={descriptionPosY}
                        width={bigWidth}
                        height={bigHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>

                <Group>
                    {colElements}
                </Group>
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/VerticalTabularDayTimesheetComponentCanvas.js